import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";
import moment from "moment";
// 采购明细类型
export enum PurchaseDetailTypeEnum {
  ALONE = "dccg", // 单次采购合同
  FRAME = "kjcg", // 框架采购合同
}

// 基本信息
export class ContractInfoReq {
  name: string = `采购合同${moment().format("YYYYMMDDHHmmss")}`; // 合同名称
  purchaseApplyId: string | undefined = undefined; // 关联采购申请
  projectWorkBudgetBizNo: string | undefined = undefined; // 施工预算编号
  projectId: string | undefined = undefined; // 所属项目 ID
  projectName: string | undefined = undefined; // 所属项目名称
  signUserId: string = getCurrentUserId(); // 签约人 ID
  signDate: string = moment().format("YYYY-MM-DD"); // 签订日期
  paperContractNo: string = ""; // 纸质合同编号
  partyACooperationCompanyId: string = getCurrentCompanyId(); // 甲方 ID
  partyBCooperationCompanyId: string|undefined = undefined; // 乙方 ID
  purchaseContractType: string = "dccg"; // 合同类别
  dueType: string = "spyf"; // 应付类型
  amount: number|undefined = undefined; // 合同签订金额
  endDate: string = ""; // 合同有效截止日期
  predictDeliveryDate: string = ""; // 预计到货日期
  invoiceType: string | undefined = undefined; // 发票类型
  taxRate: string | undefined = undefined; // 税率
  freight: number = 0; // 运费
  supplierContacts: string = ""; // 供应商联系人
  supplierMobile: string = ""; // 联系电话
  paymentAgreement: string = ""; // 付款协议
  mainClause: string = ""; // 主要条款
  remark: string = ""; // 备注
}

export class DetailRecord extends BaseReq {
  systemName: string = ""; // 系统名称
  uuid: string = ""; // 唯一ID
  id: string = "";
  purchaseContractId: string = ""; // 采购合同 ID
  purchaseApplyDetailId: string = ""; // 申请明细 ID
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialModel: string = ""; // 规格型号
  materialBrand: string = ""; // 品牌
  materialUnit: string = ""; // 结算单位
  budgetPrice: number = 0; // 预算单价
  applyCount: number = 0; // 申请数量
  count: number = 0 ; // 合同数量
  taxPrice: number = 0 ; // 合同单价-含税
  price: number = 0; // 合同单价-不含税
  taxTotalPrice: number = 0; // 采购总金额-含税(￥)
  totalPrice: number = 0; // 采购总金额-不含税(￥)
  remark: string = ""; // 备注
  sortFiled: number = 0;
  materialCategoryName: string = ""; // 材料分类名称
  materialCategoryId: string = ""; // 材料分类 ID
}

export class ContractReq extends BaseReq {
  type: PurchaseDetailTypeEnum = PurchaseDetailTypeEnum.ALONE;
  purchaseContractInfoReq: ContractInfoReq = new ContractInfoReq(); // 基本信息
  purchaseContractDetailReqs: DetailRecord[] = []; // 采购明细
  fileList: FileRecord[]; //附件
}

export class ContractPageReq extends PaginationReq {
  projectName: string | undefined = undefined; // 项目名称
  name: string | undefined = undefined; // 采购合同名称
  supplierId: string | undefined = undefined; // 供应商 ID
  signStartDate: string | undefined = undefined; // 签约开始日期
  signEndDate: string | undefined = undefined; // 签约结束日期
  purchaseContractType: string | undefined = undefined; // 合同类型
  signUserId: string | undefined = undefined; // 签约人
  contractStatus: string | undefined = undefined; //合同状态
  paperContractNo: string | undefined = undefined; // 纸制合同编号
}

export class ContractListRecord extends UpdaterResp {
  id: number = 0; // 采购合同ID
  bidNo: string = ""; // 采购合同编号
  name: string = ""; // 采购合同名称
  projectName: string = ""; // 合同名称
  signDate: string = ""; // 签约日期
  signUserId: string = ""; // 签约人 ID
  signUserName: string = ""; // 签约人名称
  partyBCooperationCompanyId: string = ""; // 乙方 ID
  partyBCooperationCompanyName: string = ""; // 乙方名称
  contractStatus: string = ""; // 合同状态
  contractStatusName: string = ""; // 合同状态名称
  purchaseContractType: string = ""; // 合同类别 code
  purchaseContractTypeName: string = ""; // 合同类别名称
  amount: number = 0; // 合同金额
  paymentStatus: string = ""; // 付款状态
  payStatusName: string = ""; // 付款状态名称
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class ContractSimpleReq extends BaseReq {
  validStatus: string = ""; // 生效状态
  addRightBizType: string | undefined = undefined;
}

export class ContractSimpleRecord {
  bizNo: string = ""; // 合同业务编号
  id: string = ""; // 合同 ID
  name: string = ""; // 合同名称
  projectId: string = ""; // 项目 ID
}

export class ContractPageResp extends PaginationResp<ContractListRecord> {}

export class ContractDetailInfo extends ContractInfoReq {
  purchaseApplyName: string = "";
  invoiceTypeName: string = "";
  taxRateName: string = "";
  purchaseContractTypeName: string = ""; // 合同类别
  partyACooperationCompanyName: string = ""; // 甲方
  partyBCooperationCompanyName: string = ""; // 乙方
  projectName: string = "";
  type: number = 0;
}

export class ContractDetailResp extends UpdaterResp {
  purchaseContractAResp: ContractDetailInfo = new ContractDetailInfo();
  purchaseContractDetailAResps: DetailRecord[] = [];
}
